export const account = {
  init: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    jobTitle: '',
    languageType: 'enu',
    imageUrl: '',
    image: '',
    isOwner: false,
    isEmailVerified: false,
    isNotificationEnabled: false,
    password: '',
    newPassword: '',
    confirmPassword: '',
  },
  fromDb: v => ({
    id: v.id,
    firstName: v.firstName,
    lastName: v.lastName,
    email: v.email,
    phone: v.phone,
    jobTitle: v.jobTitle,
    languageType: v.languageType,
    imageUrl: v.imageUrl,
    image: '',
    isOwner: v.isOwner,
    isEmailVerified: v.isEmailVerified,
    isNotificationEnabled: v.isNotificationEnabled,
    createdTime: v.createdTime,
    lastModified: v.lastModified,
    password: '',
    newPassword: '',
    confirmPassword: '',
  }),
  toDb: v => ({
    account: {
      firstName: v.firstName,
      lastName: v.lastName,
      email: v.email,
      phone: v.phone,
      jobTitle: v.jobTitle,
      languageType: v.languageType,
      isNotificationEnabled: v.isNotificationEnabled,
      imageUrl: v.imageUrl,
      image: v.image,
    },
    password: v.password,
    newPassword: v.newPassword,
    confirmPassword: v.confirmPassword,
  }),
};

export const customer = {
  init: {
    customerName: '',
    country: '',
    contactEmail: '',
    phone: '',
    address: '',
    city: '',
    zipCode: '',
    state: '',
    developerEmail: '',
    developerPhone: '',
    billingEmail: '',
    businessType: '',
    numberOfEmployees: '',
  },
  fromDb: v => ({
    id: v.id,
    customerName: v.customerName,
    country: v.country,
    contactEmail: v.contactEmail,
    phone: v.phone,
    address: v.address,
    city: v.city,
    zipCode: v.zipCode,
    state: v.state,
    developerEmail: v.developerEmail,
    developerPhone: v.developerPhone,
    billingEmail: v.billingEmail,
    businessType: v.businessType,
    numberOfEmployees: v.numberOfEmployees,
  }),
  toDb: v => ({
    customer: {
      customerName: v.customerName,
      country: v.country,
      contactEmail: v.contactEmail,
      phone: v.phone,
      address: v.address,
      city: v.city,
      zipCode: v.zipCode,
      state: v.state,
      developerEmail: v.developerEmail,
      developerPhone: v.developerPhone,
      billingEmail: v.billingEmail,
      businessType: v.businessType,
      numberOfEmployees: v.numberOfEmployees,
    },
  }),
};

export const subscription = {
  init: {
    customerId: 0,
    subscriptionType: '',
    subscriptionStatus: '',
    recurringType: '',
    maxNumberOfSkus: 0,
    maxNumberOfLooks: 0,
    isLatest: false,
    isRenewable: 'false',
  },
  fromDB: v => ({
    id: v.id,
    customerId: v.customerId,
    subscriptionType: v.subscriptionType,
    subscriptionStatus: v.subscriptionStatus,
    recurringType: v.recurringType,
    maxNumberOfSkus: v.maxNumberOfSkus,
    maxNumberOfLooks: v.maxNumberOfLooks,
    isLatest: v.isLatest,
    isRenewable: v.isRenewable.toString(),
    createdTime: v.createdTime,
    lastModified: v.lastModified,
  }),
};

export const subscriptionItem = {
  init: {
    subscription: {...subscription.init},
    intervalNo: 0,
    beginTime: 0,
    endTime: 0,
    gracePeriodDate: 0,
    isLatest: false,
  },
  fromDb: v => ({
    id: v.id,
    subscription: subscription.fromDB(v.subscription),
    intervalNo: v.intervalNo,
    beginTime: v.beginTime,
    endTime: v.endTime,
    gracePeriodDate: v.gracePeriodDate,
    changePaymentUrl: v.changePaymentUrl,
    isLatest: v.isLatest,
    createdTime: v.createdTime,
    lastModified: v.lastModified,
  }),
};

export const accountSummary = {
  fromDb: v => {
    return {
      account: v.account && account.fromDb(v.account),
      customer: v.customer && customer.fromDb(v.customer),
      subscriptionItem:
        v.subscriptionItem && subscriptionItem.fromDb(v.subscriptionItem),
      privileges: v.privileges && [...v.privileges],
      billing: {
        nextBillingTime: v.billing && v.billing.nextBillingTime,
        nextNetAmount: v.billing && v.billing.nextNetAmount,
        currencyType: v.billing && v.billing.currencyType,
      },
    };
  },
};

export const accountWithRoles = {
  toDb: (v, isNew) => {
    let account = {};
    if (isNew)
      account = {
        firstName: v.firstName,
        lastName: v.lastName,
        email: v.email,
      };
    else
      account = {
        id: v.id,
        firstName: v.firstName,
        lastName: v.lastName,
      };
    return {
      account,
      defaultStoreIds: v.defaultStoreIds,
      roleKeys: v.roleKeys,
    };
  },
};
